import { Route, Routes } from "react-router-dom";
import LoginSelector from "../../pages/LoginSelector";
import Login from "../../pages/Login";
import LoginWithPhone from "../../pages/LoginWithPhone";

const LoginRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginSelector />} />
      {/* <Route path="login/phone" element={<LoginWithPhone />} /> */}
      {/* <Route path="login/copilot" element={<Login />} /> */}
    </Routes>
  );
};

export default LoginRouting;
